var _filter, _filter2, _filter3, _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _circle3, _circle4, _path14, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _circle5, _circle6, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmptyUpdates = function SvgEmptyUpdates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 536 326"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "empty-updates_svg__a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 114,
    width: 400,
    x: 0.5,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "empty-updates_svg__b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 114,
    width: 400,
    x: 0.5,
    y: 106
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "empty-updates_svg__c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 114,
    width: 400,
    x: 0.5,
    y: 212
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#c2c9d1",
    height: 294,
    rx: 60,
    width: 350,
    x: 185.5,
    y: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillOpacity: 0.9,
    height: 294,
    rx: 60,
    width: 350,
    x: 185.5,
    y: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-updates_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8h368v82h-368z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 18h177v19h-177z",
    fill: "#c2c9d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 18h177v19h-177z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 48h267v32h-267z",
    fill: "#c2c9d1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 48h267v32h-267z",
    fill: "#fff",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 18h51v19h-51z",
    fill: "#c2c9d1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 18h51v19h-51z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 49,
    fill: "#f4af3d",
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 49,
    fill: "#fff",
    fillOpacity: 0.9,
    r: 30
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 59.5V67H46l22.12-22.12-7.5-7.5zm35.42-20.42c.78-.78.78-2.04 0-2.82l-4.68-4.68c-.78-.78-2.04-.78-2.82 0l-3.66 3.66 7.5 7.5z",
    fill: "#f4af3d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-updates_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 114h368v82h-368z",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 124h177v19h-177z",
    fill: "#c2c9d1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 124h177v19h-177z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 154h267v32h-267z",
    fill: "#c2c9d1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 154h267v32h-267z",
    fill: "#fff",
    fillOpacity: 0.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 124h51v19h-51z",
    fill: "#c2c9d1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 124h51v19h-51z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 155,
    fill: "#db5437",
    r: 30
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 155,
    fill: "#fff",
    fillOpacity: 0.9,
    r: 30
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 135c-7.74 0-14 6.26-14 14 0 10.5 14 26 14 26s14-15.5 14-26c0-7.74-6.26-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
    fill: "#db5437"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-updates_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 220h368v82h-368z",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 230h177v19h-177z",
    fill: "#c2c9d1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 230h177v19h-177z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 260h267v32h-267z",
    fill: "#c2c9d1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 260h267v32h-267z",
    fill: "#fff",
    fillOpacity: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 230h51v19h-51z",
    fill: "#c2c9d1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 230h51v19h-51z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 261,
    fill: "#003049",
    r: 30
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 261,
    fill: "#fff",
    fillOpacity: 0.9,
    r: 30
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 269h16v4h-16zm0-8h16v4h-16zm12-20h-16c-2.2 0-4 1.8-4 4v32c0 2.2 1.78 4 3.98 4H68.5c2.2 0 4-1.8 4-4v-24zm8 36h-24v-32h14v10h10z",
    fill: "#003049"
  })));
};
export default SvgEmptyUpdates;